import { render, staticRenderFns } from "./AppHeader.vue?vue&type=template&id=705371f0"
import script from "./AppHeader.vue?vue&type=script&lang=js"
export * from "./AppHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/cmgames.septemberdev.nl/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('705371f0')) {
      api.createRecord('705371f0', component.options)
    } else {
      api.reload('705371f0', component.options)
    }
    module.hot.accept("./AppHeader.vue?vue&type=template&id=705371f0", function () {
      api.rerender('705371f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/student/vue/components/AppHeader.vue"
export default component.exports